import React, { useContext, useEffect, useState } from "react";
import PedidosContext from "../../../../Context/Pedidos/PedidosContext";
import Card from "../Card/Card";
import { Alert, Box, Grid } from "@mui/material";
import OrdersSkeleton from "../OrdersSkeleton";

const ValidatePayment = () => {
  const [active, setActive] = useState(-1);
  const [loading, setLoading] = useState(true);
  const handleCollapse = (indx) => {
    if (active === indx) {
      setActive(-1);
    } else {
      setActive(indx);
    }
  };
  const { orders_client, GetValidandoPago } = useContext(PedidosContext);
  useEffect(() => {
    setLoading(true);
    const result = GetValidandoPago();
    if (result && typeof result.finally === "function") {
      result.finally(() => setLoading(false));
    } else {
      setTimeout(() => setLoading(false), 500);
    }
  }, []);

  if (loading) return <OrdersSkeleton count={3} />;

  return (
    <Box sx={{ mt: 1 }}>
      {orders_client.length > 0 ? (
        <Grid container spacing={2}>
          {orders_client.map((order, index) => (
            <Grid item xs={12} key={index}>
              <Card
                key={index}
                index={index}
                onCollapse={handleCollapse}
                order={order}
                active={active}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Alert
          severity="info"
          sx={{
            mt: 2,
            borderRadius: 2,
            border: "1px solid #E3F2FD",
          }}
        >
          No tienes pedidos en validación de pago.
        </Alert>
      )}
    </Box>
  );
};

export default ValidatePayment;
